import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useManualTestStore = defineStore('manualTest', () => {
  // manual test trigger
  const manualTestTriggerPopoverVisible = ref(false)
  const manualTestTriggerEl = ref()
  const manualTestTriggerData = ref()
  const showManualTestTrigger = (el: any, data: any) => {
    manualTestTriggerEl.value = el
    manualTestTriggerData.value = data
    manualTestTriggerPopoverVisible.value = true
  }
  function hideManualTestTrigger() {
    manualTestTriggerEl.value = null
    manualTestTriggerData.value = null
    manualTestTriggerPopoverVisible.value = false
  }

  const clusterId = ref<number | string>(0)
  const zoneId = ref<number | string>(0)
  const isShowManualTestDialog = ref(false)
  const manualTestDialogContentType = ref('manualTestList')

  const showManualTestDialog = (
    clickedClusterId: number | string,
    clickedZoneId = 0
  ): void => {
    clusterId.value = clickedClusterId
    zoneId.value = clickedZoneId
    isShowManualTestDialog.value = true
  }

  return {
    manualTestTriggerPopoverVisible,
    manualTestTriggerEl,
    manualTestTriggerData,
    showManualTestTrigger,
    hideManualTestTrigger,

    clusterId,
    zoneId,
    isShowManualTestDialog,
    manualTestDialogContentType,
    showManualTestDialog
  }
})
